import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { GreyContainer, LargeWrapper, PopoverHeader } from './SharedStyleComponents';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAssistantError = ({
  body,
  label,
  onCancel,
  onTryAgain
}) => {
  return /*#__PURE__*/_jsxs(LargeWrapper, {
    "data-test-id": "error-screen",
    children: [/*#__PURE__*/_jsx(PopoverHeader, {
      label: label,
      body: body,
      onCancel: onCancel
    }), /*#__PURE__*/_jsx(Illustration, {
      height: "70px",
      name: "errors/general",
      margin: "200"
    }), /*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.heading"
      })
    }), /*#__PURE__*/_jsx(Text, {
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "contentAssistantError.body"
      })
    }), /*#__PURE__*/_jsx(GreyContainer, {
      hideNavigation: true,
      children: /*#__PURE__*/_jsx(Button, {
        size: "small",
        use: "tertiary",
        onClick: onTryAgain,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentAssistantError.tryAgain"
        })
      })
    })]
  });
};
export default ContentAssistantError;